import { createAuth0 } from '@auth0/auth0-vue'

// Variable to store the Auth0 instance
let auth0Instance = null

// Function to create the Auth0 instance
export const createAuth0Instance = auth0Params => {
  auth0Instance = createAuth0(auth0Params)
  return auth0Instance
}

// Function to get the Auth0 instance
export const getAuth0Instance = () => {
  if (!auth0Instance) {
    throw new Error('Auth0 is not initialized. Call createAuth0Instance first.')
  }
  return auth0Instance
}

// Function to get the access token outside of components
export const getAccessTokenSilently = async (options = {}) => {
  const auth0 = getAuth0Instance()
  return await auth0.getAccessTokenSilently(options)
}
